export default __webpack_public_path__ + "static/1566-715823de6d20f06f33a73e203405874b.gif";